import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';

// components
import PreQuoteTitle from '../shared/delivery/PreQuoteTitle';
import DeactivatedQuoteExplanation from './DeactivatedQuoteExplanation';
import DeliveryOption from '../shared/delivery/DeliveryOption';

function DeactivatedQuotes({ preCheckoutTransaction, deliveryOptions = [], sku, offerCurrency }) {
    if (!preCheckoutTransaction) {
        return null;
    }
    const quotes = deliveryOptions
        .filter(({ serviceId }) => !!serviceId)
        .map(option => option.serviceId);
    const deactivatedQuotes = (get(preCheckoutTransaction, 'shipmentQuotes') || []).filter(
        ({ serviceId, isLocalPickup, hasBeenAcceptedByDealer, isPreQuote }) =>
            !isLocalPickup && hasBeenAcceptedByDealer && !quotes.includes(serviceId) && !isPreQuote
    );

    return (
        !!deactivatedQuotes.length && (
            <div>
                {deactivatedQuotes.map(quote => {
                    const { serviceMethodType } = get(quote, 'serviceMethod') || {};
                    const testName = `deactivated-${serviceMethodType}`;
                    const title = (
                        <span>
                            <PreQuoteTitle
                                shipmentQuote={quote}
                                sku={sku}
                                transaction={preCheckoutTransaction}
                                offerCurrency={offerCurrency}
                            />{' '}
                            <DeactivatedQuoteExplanation shipmentQuote={quote} />
                        </span>
                    );
                    return (
                        <DeliveryOption
                            key={quote.serviceId}
                            value={null}
                            title={title}
                            testName={testName}
                            disabled
                            onSelect={() => {}}
                        />
                    );
                })}
            </div>
        )
    );
}

DeactivatedQuotes.propTypes = {
    preCheckoutTransaction: PropTypes.object,
    deliveryOptions: PropTypes.array.isRequired,
    sku: PropTypes.object,
    offerCurrency: PropTypes.string,
    isRedirect: PropTypes.bool,
};

const ConnectedDeactivatedQuotes = connect(({ transaction, pane }) => ({
    offerCurrency: transaction.offerCurrency,
    isRedirect: pane.isRedirect,
}))(DeactivatedQuotes);

export default createFragmentContainer(ConnectedDeactivatedQuotes, {
    preCheckoutTransaction: graphql`
        fragment DeactivatedQuotes_preCheckoutTransaction on Transaction {
            ...PreQuoteTitle_transaction
            serviceId
            shipmentQuotes {
                ...PreQuoteTitle_shipmentQuote
                ...DeactivatedQuoteExplanation_shipmentQuote
                serviceId
                isLocalPickup
                hasBeenAcceptedByDealer
                serviceMethod {
                    serviceMethodType
                }
                isPreQuote
            }
        }
    `,
    deliveryOptions: graphql`
        fragment DeactivatedQuotes_deliveryOptions on ShipmentQuote @relay(plural: true) {
            serviceId
        }
    `,
    sku: graphql`
        fragment DeactivatedQuotes_sku on ItemSkuType {
            ...PreQuoteTitle_sku
        }
    `,
});
